// egp

import { getDataCommon } from "./common";

const getProcurement = () => getDataCommon("egp.json");

export { getProcurement };
